<template>
  <section id="voting_experience_page"
  :class="$mq">

    <!-- REMOVE FOR PRODUCTION -->
    <!-- <dev-period-simulator
    v-if="env == 'development'"
    ></dev-period-simulator> -->
    <!-- END REMOVE FOR PRODUCTION -->
    
    <div class="container">
      <div class="row">
        <div class="col-12">

          <!-- "VOTING NOT OPEN YET" DISPLAY -->
          <intro-not-started
          v-if="instance_period == 'Event not started' || instance_period == 'Nomination Period' || instance_period == 'Nomination Intermission'"
          :vote_start_date="vote_period_data.start"
          :tz_offset="timezone_offset"
          ></intro-not-started>

          <!-- VOTING INTERMISSION -->
          <intro-voting-intermission
          v-if="instance_period == 'Voting Intermission'"
          :vote_start_date="vote_period_data.start"
          :tz_offset="timezone_offset"
          ></intro-voting-intermission>

          <!-- WINNERS PERIOD AND BEYOND -->
          <intro-winners-period
          v-if="instance_period == 'Winners Period' || instance_period == 'Event has ended'"
          :vote_start_date="vote_period_data.start"
          :tz_offset="timezone_offset"
          ></intro-winners-period>

          <!-- "VOTING PERIOD" DISPLAY -->
          <div class="voting_container"
          v-if="instance_period == 'Voting Period'"
          >

            <h3 class="section_title">Vote Now</h3>

            <trans-zoom>

              <!-- LOGIN PROMPT FOR NON-LOGGED-IN USERS -->
              <login-prompt
              v-if="!is_logged_in"
              ></login-prompt>
              
              <!-- VOTE CARD CONTAINER FOR LOGGED-IN USERS ONLY -->
              <div class="vote_card_outer_container"
              v-if="is_logged_in"
              >

                <trans-bounce>

                  <div class="loading_contests_box"
                  v-if="!unvoted_contest_details[card_a_index] && !unvoted_contest_details[card_b_index] && finished_all_daily_votes == false"
                  >
                    Loading contests...
                  </div>

                  <!-- BEGIN "COMPLETED ALL VOTING" MESSAGE -->
                  

                  <div class="completed_voting_message"
                  v-if="finished_all_daily_votes == true"
                  >
                    
                    <div class="loading_contests_box">
                      All done!
                    </div>

                    <p>
                      <strong>Congrats!</strong> You reached the end of our contest list, and that's a lot. 
                    </p>

                    <p>
                      <strong>Check back each day</strong> to get another chance to vote for your favorites or simply <strong>refresh this page</strong> to see any contest you might have missed today. You can vote on each contest once per day during the voting period.
                    </p>

                    <p>
                      Your favorites need your help to win, so get in <strong>as many votes as you can</strong> before voting closes!
                    </p>
                  </div>
                  <!-- END "COMPLETED ALL VOTING" MESSAGE -->

                  <!-- VOTE CARD "A" -->
                  <vote-card
                  v-if="show_card_a && unvoted_contest_details[card_a_index] && finished_all_daily_votes == false"
                  :contest="unvoted_contest_details[card_a_index]"
                  :instance_contestid="unvoted_contest_details[card_a_index].instance_contestid"
                  :contestants="unvoted_contest_details[card_a_index].finalists"
                  :vote_complete="vote_complete"
                  is_single_contest="false"
                  @contest_vote_submitted="record_vote"
                  @next_contest_requested="change_vote_card"
                  key="vote_card_a"
                  ></vote-card>

                  <!-- VOTE CARD "B" -->
                  <vote-card
                  v-if="!show_card_a && unvoted_contest_details[card_b_index] && finished_all_daily_votes == false"
                  :contest="unvoted_contest_details[card_b_index]"
                  :instance_contestid="unvoted_contest_details[card_b_index].instance_contestid"
                  :contestants="unvoted_contest_details[card_b_index].finalists"
                  :vote_complete="vote_complete"
                  is_single_contest="false"
                  @contest_vote_submitted="record_vote"
                  @next_contest_requested="change_vote_card"
                  key="vote_card_b"
                  ></vote-card>

                </trans-bounce>

              </div>

            </trans-zoom>

          </div>

        </div>
      </div>
    </div>
    

  </section>
</template>

<script>
import VoteCard from '@/features/vote/vote_card.vue';
import LoginPrompt from '@/features/login/login_prompt.vue';
import TransZoom from '@/components/transitions/trans_zoom.vue';
import TransBounce from '@/components/transitions/trans_bounce_inL_outR.vue';
import IntroNotStarted from '@/features/vote/intros/vote_intro_event_not_started.vue';
import IntroVotingPeriod from '@/features/vote/intros/vote_intro_voting_period.vue';
import IntroVotingIntermission from '@/features/vote/intros/vote_intro_voting_intermission.vue';
import IntroWinnersPeriod from '@/features/vote/intros/vote_intro_winners_period.vue';
import DevPeriodSimulator from '@/components/dev_tools/dev_period_simulator.vue';

export default {
  name: 'voting_experience_page',
  data () {
    return {
      vote_complete: false,
      voting_period_started: false, // NEED TO MAKE THIS A CALCULATION FROM STORE
      card_a_index: 0,
      card_b_index: 1,
      show_card_a: true,
      unvoted_contest_details: [],
      contest_preload_amount: 8,
      contest_preload_advance: 2,
      last_voted_on_index: 0,
      env: this.$root.state.env,
      init_vote_queue_started: false,
      finished_all_daily_votes: false
    }
  },
  created() {
    
  },
  mounted() {
    document.dispatchEvent(new Event('prerender-trigger'));

    if(this.user_publicid != 0 && this.instanceid != 0) {
      this.init_vote_queue();
    }
    // this.init_vote_queue();
    // this.$root.store.voting.get_contest_list_by_type(1, 'unvoted', this.user_publicid);
  },
  watch: {
    // WAIT FOR SUCCESSFUL LOGIN BEFORE DOING ANYTHING
    user_publicid: function(new_val, old_val) {
      let vm = this;

      vm.check_for_prereqs(vm.init_vote_queue);
    },

    // WAIT FOR INSTANCEID BEFORE DOING ANYTHING
    instanceid: function(new_val, old_val) {
      let vm = this;

      vm.check_for_prereqs(vm.init_vote_queue);
    },

    // FORCE UNVOTED REFRESH IF TOGGLED TO TRUE
    force_unvoted_refresh: function(new_val, old_val) {
      if(new_val === true) {
        this.init_vote_queue();
        this.$root.store.voting.change_force_unvoted_refresh(false);
      }
    }
  },
  computed: {
    instance_period: {
      get: function() {
        return this.$root.store.instances.get_current_active_instance_period();
      }
    },
    is_logged_in: function() {
      return this.$root.store.session.check_login_status();
    },
    master_contest_list: function() {
      return this.$root.store.contests.get_current_master_contest_list();
    },
    user_publicid: function() {
      return this.$root.store.session.get_userid();
    },
    instanceid: function() {
      return this.$root.store.instances.get_current_instanceid();
    },
    unvoted_contest_list: function() {
      return this.$root.store.voting.get_current_unvoted_contest_list();
    },
    timezone_offset: function() {
      return this.$root.store.instances.get_current_timezone_offset();
    },
    vote_period_data: function() {
      return this.$root.store.instances.get_specific_instance_period('Voting Period');
    },
    force_unvoted_refresh: function() {
      return this.$root.store.voting.get_current_force_unvoted_refresh();
    }
  },
  methods: {
    check_for_prereqs: function(callback) {
      let vm = this;

      if(
        typeof vm.instanceid != 'undefined'
         && vm.instanceid > 0
         && typeof vm.user_publicid != 'undefined'
         && vm.user_publicid != 1
         && vm.init_vote_queue_started == false
      ) {
        // RUN CALLBACK
        callback();
      }
      else {
        // SET TIMEOUT TO RUN AGAIN
        setTimeout(function() {
          vm.check_for_prereqs(callback);
        }, 200);
      }
    },
    init_vote_queue: function() {
      let vm = this;

      vm.init_vote_queue_started = true;
      vm.$set(vm, 'finished_all_daily_votes', false);
      
      // GET "UNVOTED" CONTEST IDs
      vm.$root.store.voting.get_contest_list_by_type(vm.instanceid, 'unvoted', vm.user_publicid)
        .then(function(response) {
          // console.log('response.data.data.length: ', response.data.data.length);
          if(response.data.data.length == 0) {
            vm.$set(vm, 'finished_all_daily_votes', true);
          }

          // ADJUST LIST TO BE ARRAY OF VALUES INSTEAD OF OBJECTS
          let new_list = [];
          let old_list = response.data.data;
          for(var key in old_list) {
            new_list.push(old_list[key].instance_contestid);
          }
          // console.log('new_list: ', new_list);
          vm.$root.store.voting.store_unvoted_contest_list(new_list);
        })
        .then(function() {

          // RANDOMIZE LIST
          vm.randomize_unvoted_contest_list();

          // GET FIRST SET OF CONTEST DETAILS
          return vm.$root.store.contests.get_batch_contest_voting_details(
            vm.unvoted_contest_list.slice(0, vm.contest_preload_amount),
            vm.user_publicid
          );
        })
        .then(function(response) {
          if(response.data.data.length == 0) {
            vm.$set(vm, 'finished_all_daily_votes', true);
          }

          vm.$set(vm, 'unvoted_contest_details', response.data.data);
        })
    },
    randomize_unvoted_contest_list: function() {
      this.unvoted_contest_list.sort(function() { return 0.5 - Math.random() });
    },
    randomize_unvoted_contest_details: function() {
      this.unvoted_contest_details.sort(function() { return 0.5 - Math.random() });
    },
    get_batch_of_contest_details: function() {
      let vm = this;
      let start_index = vm.last_voted_on_index + vm.contest_preload_advance + 1;
      let stop_index = start_index + vm.contest_preload_amount;
      let list = vm.unvoted_contest_list.slice(start_index, stop_index);
      
      vm.$root.store.contests.get_batch_contest_voting_details(list, vm.user_publicid)
        .then(function(response) {
          if(typeof response.data.data != 'undefined' && response.data.data.length > 0) {
            let merged_details = vm.unvoted_contest_details;
            merged_details = merged_details.concat(response.data.data);
            
            vm.$set(vm, 'unvoted_contest_details', merged_details);
            // vm.randomize_unvoted_contest_details();
          }
        })
    },
    get_single_contest_details: function() {
      let vm = this;
      let start_index = vm.last_voted_on_index + vm.contest_preload_amount;
      let stop_index = start_index + 1;
      let list = vm.unvoted_contest_list.slice(start_index, stop_index);
      if(typeof list[0] != 'string') {
        list[0] = list[0].instance_contestid;
      }
      
      vm.$root.store.contests.get_batch_contest_voting_details(list, vm.user_publicid)
        .then(function(response) {
          if(typeof response.data.data != 'undefined' && response.data.data.length > 0) {
            vm.unvoted_contest_details.push(response.data.data[0]);
          }
        })
    },
    change_vote_card: function() {
        let vm = this;

        // UPDATE "VOTE_COMPLETE" TO FALSE TO RESET
        vm.vote_complete = false;

        // UPDATE 
        if(vm.show_card_a == false) {
          // THIS IS CARD "B"
          vm.last_voted_on_index = vm.card_b_index;
          vm.card_b_index = vm.card_b_index + 2;
          vm.show_card_a = true;
        }
        else {
          // THIS IS CARD "A"
          vm.last_voted_on_index = vm.card_a_index;
          vm.card_a_index = vm.card_a_index + 2;
          vm.show_card_a = false;
        }

        // PRELOAD MORE CONTEST CONTESTS
        let loaded_contest_count = vm.unvoted_contest_details.length;
        let loaded_contest_count_last_index = loaded_contest_count -1;
        let loaded_voted_diff = loaded_contest_count_last_index - vm.last_voted_on_index;
        /*console.log('loaded_contest_count: ', loaded_contest_count);
        console.log('loaded_contest_count_last_index: ', loaded_contest_count_last_index);
        console.log('vm.last_voted_on_index: ', vm.last_voted_on_index);
        console.log('loaded_voted_diff: ', loaded_voted_diff);*/
        if(loaded_voted_diff == vm.contest_preload_advance) {
          // console.log('NOW WANTING TO LOAD MORE CONTESTS: ', loaded_voted_diff);
          vm.get_batch_of_contest_details();
        }
        else if(loaded_voted_diff == 0) {
          vm.$set(vm, 'finished_all_daily_votes', true);
        }
        
        // vm.get_single_contest_details();

        setTimeout(function() {
          window.scrollTo(0,0);
        }, 1000);
        
    },
    record_vote: function(contestant) {
      let vm = this;
      
      // TRY TO SAVE VOTE
      vm.$root.store.voting.record_vote(vm.user_publicid, contestant.instance_contestid, contestant.finalistid)
        .then(function(response) {

          // UPDATE "VOTE_COMPLETE" TO TRUE
          vm.vote_complete = true;

          // FIRE GA PAGEVIEW
          vm.$ga.page(vm.$router);
          /*vm.$ga.page({
            page: '',
            title: vm.$metaInfo.title,
            location: ''
          })*/

          // FIRE GA EVENT
          vm.$ga.event({
            eventCategory: 'Votes',
            eventAction: contestant.name,
            eventLabel: contestant.contest_label
          })

          // UPDATE "VOTED COUNT"
          let voted_count = vm.$root.store.voting.get_voted_count();
          voted_count++;
          vm.$root.store.voting.store_voted_count(voted_count);

          // ARTIFICIAL DELAY TO SHOW USER THAT VOTE WAS COMPLETE
          setTimeout(function() {
            vm.change_vote_card();
          }, 1500);
        })
      
    },
    goto_path: function(path_name) {
      this.$root.store.goto_path(path_name);
    }
  },
  metaInfo() {
    return {
      title: 'Vote Now',
      titleTemplate: '%s | Best of Dayton 2019',
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: 'Vote for your favorite local businesses, food, service providers, and more!'
        },
        {
          property: 'og:title',
          content: 'Vote for Best of Dayton 2019'
        },
        {
          property: 'og:site_name',
          content: 'Best of Dayton 2019'
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:description',
          content: 'Vote for your favorite local businesses, food, service providers, and more!'
        },
        {
          property: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          property: 'twitter:site',
          content: '@daytondotcom'
        },
        {
          property: 'og:image',
          content: 'https://www.dayton.com/rf/image_large/Pub/Web/Dayton/Special%20Contents/Links/Images/DDC_BoD_VOTE_FBevent_1920x1080.jpg'
        }
      ]
    }
  },
  components: {
    VoteCard,
    LoginPrompt,
    TransZoom,
    TransBounce,
    IntroNotStarted,
    IntroVotingPeriod,
    IntroVotingIntermission,
    IntroWinnersPeriod,
    DevPeriodSimulator
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

#voting_experience_page {

  .loading_contests_box {
    text-align: center;
    background: #EEE;
    font-size: 1.4em;
    padding: 1em;
    margin-bottom: 1em;
  }

  &.desktop, &.laptop {
    width: 40%;
    margin: 0 auto;
  }

}

</style>


// WEBPACK FOOTER //
// src/pages/VotingExperiencePage.vue